// eslint-disable-next-line import/no-unresolved
import { useAppSelector } from "src/utils/hooks/useAppSelector";
// eslint-disable-next-line import/no-unresolved
import { onChangeIndianCurrency } from "src/helpers/FormDetails";
import CustomReviewField from "../../../../../shared/CustomReviewField";
import CustomLabel from "../../../../../shared/CustomLabel";

function PremiumDetailsReview() {
  const loanDetails = useAppSelector((state) => state.loanDetails);
  const premiumDetailsReviewMefFields = useAppSelector(
    (state) => state.masterdata_reducer?.mefJourneySchema?.planDetails
  );

  return (
    <div>
      <div className="flex justify-between mt-8">
        <div className="text-base font-bold">Premium Details</div>
      </div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 md:gap-x-28 gap-x-3 mt-6 max-sm:ml-4 ">
        {(loanDetails?.premiumDetails?.premiumMode ||
          premiumDetailsReviewMefFields?.premiumDetails?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{premiumDetailsReviewMefFields?.premiumDetails?.label}</CustomLabel>
            <CustomReviewField>{loanDetails?.premiumDetails?.premiumMode || "-"}</CustomReviewField>
          </div>
        )}

        {(loanDetails?.premiumDetails?.totalPayment ||
          premiumDetailsReviewMefFields?.totalPayment?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{premiumDetailsReviewMefFields?.totalPayment?.label}</CustomLabel>
            <CustomReviewField>
              ₹ {onChangeIndianCurrency(loanDetails?.premiumDetails?.totalPayment || "-")}
            </CustomReviewField>
          </div>
        )}
      </div>
    </div>
  );
}
export default PremiumDetailsReview;
